import PropTypes from 'prop-types';
import React from 'react';

const RETAIN_SDK_JS = `(function(i,s,o,g,r,a,m){i['ProfitWellObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
  })(window,document,'script','https://dna8twue3dlxq.cloudfront.net/js/profitwell.js','profitwell');`;

export class RetainSDK extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.currentUser && !this.props.currentUser && this.isProfitwellLoaded()) {
      this.profitwell('user_email', nextProps.currentUser.email);
    }
    return false;
  }

  isProfitwellLoaded() {
    return !!window.profitwell;
  }

  /* istanbul ignore next */
  profitwell(type, data) {
    return window.profitwell(type, data);
  }

  isRetainEnabled() {
    return !__LOCAL_DEV__ || __TEST__;
  }

  render() {
    const { currentUser, accountKey } = this.props;

    if (!this.isRetainEnabled()) {
      return false;
    }

    let userSetJs = `profitwell('auth_token', '${accountKey}');`;

    // Profitwell uses custom path params to allow non-logged in users to update their information
    // when coming from the Profitwell emails
    if (currentUser && currentUser.email) {
      userSetJs += `profitwell('user_email', ${JSON.stringify(currentUser.email)});`;
    }

    return (
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: (RETAIN_SDK_JS + userSetJs).replace(/\n/g, '') }}
      />
    );
  }
}

RetainSDK.propTypes = {
  currentUser: PropTypes.object,
  accountKey: PropTypes.string.isRequired,
};
